import React from "react";

class HubspotForm extends React.Component {
    componentDidMount() {
        const script = document.createElement('script');
      script.src = 'https://js.hsforms.net/forms/v2.js';
      document.body.appendChild(script);
      
      script.addEventListener('load', () => {
          if(window.hbspt) {
            window.hbspt.forms.create({
              portalId: '7415733',
            formId: 'd58319dd-4288-470c-a089-fd17fd63dd05',
            target: '#hubspotForm'
          })
        }
      });
    }

      render() {
        return (
            <div>
              <div id="hubspotForm"></div>
            </div>
      );
    }
  }
  /* 
  ReactDOM.render(
      <HubspotForm />,
    document.getElementById('content')
  ) */

  export default HubspotForm;